// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.shared.types.repository.FileConflicts

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { ConflictRegionData, ConflictRegionStore } from "./ConflictRegion.generated";

export interface FileConflictsData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "FileConflicts";
    path: string;
    regions: ConflictRegionData[];
}

export class FileConflictsStore {
    readonly _entity_class_name = "FileConflicts" as const;
    path: string;
    regions: ConflictRegionStore[];
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: FileConflictsData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.path = wrapEntity(data.path, transport, [...chainPath, "path"]);
        this.regions = wrapEntity(data.regions, transport, [...chainPath, "regions"]);
        makeObservable(this, {
            path: observable,
            regions: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("FileConflicts", FileConflictsStore);
